import {
  deselectEntries,
  setHoverDeleteButton,
} from '@databases/redux/cellSelections/actions';
import { appStore } from '@databases/redux/store';

/**
 * Dispatches actions to clear the hover state of the delete button and deselect specified entries.
 */
export function onLeaveDeleteEntryButton(selectedEntryIds: string[], contentId: string) {
  appStore.dispatch(setHoverDeleteButton({ value: null }));
  appStore.dispatch(
    deselectEntries({
      contentId,
      entryIds: selectedEntryIds,
    })
  );
}
